import Shape from './shape';

export default Shape;
